import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const PATHS = ["/pagamento-ricevuto", "/app/abbonamento", "/app/founder", "/app/pacchetti"];
const SENT = "sq_gads_sent_";

// Sends a backend-verified purchase once per transaction (never in Stripe test mode).
export function reportVerifiedPurchase(d) {
  if (!d || localStorage.getItem(SENT + d.transaction_id)) { return; }
  localStorage.setItem(SENT + d.transaction_id, "1");
  if (d.test_mode) { console.info("[Google Ads] TEST: conversione non inviata", d); window.__sqLastAdsTest = d; return; }
  tracciaAcquistoSnapQuote(d.transaction_id, d.value, d.send_to);
}

export function tracciaAcquistoSnapQuote(idOrdine, importoEuro, sendTo) {
  if (!idOrdine || !Number.isFinite(importoEuro) || importoEuro <= 0 || !sendTo) {
    return false;
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("event", "conversion", { send_to: sendTo, value: importoEuro, currency: "EUR", transaction_id: String(idOrdine) });
  return true;
}

// Application call conversion: only after the backend confirms the booking; once per booking, no value.
export async function reportVerifiedBooking(token) {
  try {
    const { data: d } = await api.get(`/public/ads/booking/${encodeURIComponent(token)}`);
    if (!d.track || localStorage.getItem(SENT + d.transaction_id)) { return d; }
    localStorage.setItem(SENT + d.transaction_id, "1");
    if (d.test_mode || !d.send_to) { console.info("[Google Ads] conversione call non inviata", { ...d, send_to: d.send_to ? "set" : "missing" }); window.__sqLastAdsTest = d; return d; }
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("event", "conversion", { send_to: d.send_to, transaction_id: d.transaction_id });
    return d;
  } catch { return null; }
}

// Fires the Google Ads purchase only after the backend confirms the Stripe session is paid; once per transaction.
export function AdsConversion() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const sid = new URLSearchParams(search).get("session_id");
    if (!sid || !PATHS.includes(pathname) || sessionStorage.getItem(`${SENT}sid_${sid}`)) { return undefined; }
    let tries = 0, stop = false, timer;
    const check = async () => {
      try {
        const { data } = await api.get(`/public/ads/purchase/${encodeURIComponent(sid)}`);
        if (stop) { return; }
        if (data.track) {
          sessionStorage.setItem(`${SENT}sid_${sid}`, "1");
          reportVerifiedPurchase(data);
          if (pathname === "/app/founder") { trackEvent("founder_purchase", { value: data.value, position: sessionStorage.getItem("sq_founder_src") || "" }); }
          return;
        }
        if (data.reason === "not_paid" && tries < 10) { tries += 1; timer = setTimeout(check, 3000); }
      } catch { /* unverifiable session: nothing is tracked */ }
    };
    check();
    return () => { stop = true; clearTimeout(timer); };
  }, [pathname, search]);
  return null;
}
